import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiDollarSign, FiPieChart, FiBarChart2, FiCreditCard, FiRepeat } from 'react-icons/fi';
import { MdPayment } from 'react-icons/md';
import { SidebarItem, MenuAccordionItem } from '../SidebarComponents';

const FinancesMenu = () => {
  const location = useLocation();
  
  // Check if current route is active
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  // Check if an accordion is active based on subroutes
  const isAccordionActive = (parentPath) => {
    return location.pathname.startsWith(parentPath);
  };

  return (
    <MenuAccordionItem
      icon={FiDollarSign}
      label="Finanças"
      isActive={isAccordionActive('/financas')}
      defaultIsOpen={isAccordionActive('/financas')}
    >
      <SidebarItem 
        icon={FiPieChart} 
        label="Fluxo de Caixa" 
        to="/financas/fluxocaixa" 
        active={isActive('/financas/fluxocaixa')} 
        isSubmenuItem
      />
      <SidebarItem
        icon={MdPayment}
        label="Pagamentos"
        to="/financas/pagamentos"
        active={isActive('/financas/pagamentos')}
        isSubmenuItem
      />
      <SidebarItem
        icon={FiRepeat}
        label="Assinaturas"
        to="/financas/assinaturas"
        active={isActive('/financas/assinaturas')}
        isSubmenuItem
      />
      <SidebarItem
        icon={FiBarChart2}
        label="Contas a Receber"
        to="/financas/contasreceber"
        active={isActive('/financas/contasreceber')}
        isSubmenuItem
      />
      <SidebarItem
        icon={FiCreditCard}
        label="Contas a Pagar"
        to="/financas/contaspagar"
        active={isActive('/financas/contaspagar')}
        isSubmenuItem
      />
    </MenuAccordionItem>
  );
};

export default FinancesMenu;